import { lazy } from 'react'

export const SubscriptionsGoogleVariant2 = lazy(
  () => import('./SubscriptionsGoogleVariant2'),
)
